
export default function Loading() {
    return (
        <div className="row" style={{ marginTop: "2rem" }}>
            <div className="column" style={{ color: "#fff", textAlign: "center" }}>Cargando...</div>
        </div>
    )
}

